import React, { useEffect, useRef, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import $ from "jquery";
import "bootstrap-datepicker";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import moment from "moment";
import Layout from "../../../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CreateUserUi from "./CreateUserUi";
import {
  useAddUserMutation,
  useEditUserDataMutation,
  useEditUserMutation,
} from "../../../store/Api/users";
import { hidetoast, useDecodeToken } from "../../../Utils/function";
import { useGetRrbQuery } from "../../../store/Api/common";
import {
  useralidationSchemaSe,
  validationSchemaFi,
  validationSchemaSe,
} from "../../../Utils/ValidationSchema";
function CreateUser() {
  const dispatch = useDispatch();
  // const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation(); // Access state
  const { state } = location;
  const id = state?.data?.id
  const decodedToken = useDecodeToken();
  const [addUser] = useAddUserMutation();
  const [updateUser] = useEditUserMutation();
  const { data, isFetching, isLoading } = useGetRrbQuery({});
  const rrb = data?.data;
  // Define validation schema using Yup
  const validationSchema =
  ( decodedToken?.role == 3 || decodedToken?.role == 4) ? useralidationSchemaSe : validationSchemaFi;
  const [editUser] = useEditUserDataMutation();
  const toast = useSelector((state) => state.toast);

  // Auto-hide toast after 3 seconds
 useEffect(() => {
    if (toast.message) {
       hidetoast()
      // const timer = setTimeout(() => {
    }
  }, [toast.message, dispatch]);


  const handleSubmit = async (values) => {
    
    const trimmedValues = Object.fromEntries(
      Object.entries(values).map(([key, value]) => [
        key,
        typeof value === "string" ? value.trim() : value,
      ])
    );

    try {
      const response = id
        ? await editUser({ id: id, ...trimmedValues })
        : await addUser({ ...trimmedValues, role: 2 });
      if (response?.data?.success) {
        navigate("/auditors");
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };
  return (
    <Layout>
      <Formik
        initialValues={
          ( decodedToken?.role == 3 || decodedToken?.role == 4)
            ? {
                firstname: id ? state?.data?.firstname : "",
                lastname: id ? state?.data?.lastname : "",
                designation: id ? state?.data?.designation : "",
                phone_number: id ? state?.data?.phone_number : "",
                rrb_id: id ? state?.data?.rrb_id : "",
              }
            : {
                firstname: id ? state?.data?.firstname : "",
                lastname: id ? state?.data?.lastname : "",
                designation: id ? state?.data?.designation : "",
                phone_number: id ? state?.data?.phone_number : "",
              }
        }
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <CreateUserUi
            formik={formik}
            id={id}
            rrb={rrb?.data}
            decodedToken={decodedToken}
            toast={toast}
          />
        )}
      </Formik>
    </Layout>
  );
}

export default CreateUser;
